const BlogPostingSchema = ({
  headline,
  description,
  url,
  image,
  datePublished,
  authorName = "ONBBITS"
}) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",

  "@id": `${url}#blogposting`,

  "headline": headline,
  "description": description,

  "url": url,

  ...(image && {
    "image": [image]
  }),

  ...(datePublished && {
    "datePublished": datePublished
  }),

  "author": {
    "@type": "Organization",
    "name": authorName,
    "@id": "https://onbbits.io/#organization"
  },

  "publisher": {
    "@id": "https://onbbits.io/#organization"
  },

  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `${url}#webpage`
  }
});

export default BlogPostingSchema;